import Enlang from './entries/en-US';
import SvLang from './entries/sv-SE';

const AppLocale = {
  en: Enlang,
  sv: SvLang,
};
export default AppLocale;
